function e(e){return"sevenPc"===e?"7PC":e.replace(/([a-z])([A-Z])/g,"$1 $2").replace(/^([a-z]+)/,e=>e.toUpperCase()).replace(/ (\w)/g,(e,p)=>" "+p.toUpperCase())}export{e as formatScoringSystemCode};
